import * as TechValueCodes from "~/features/selectionAssistant/gearbox/components/DimensionsFilter/constants/TechValueCodes";
import { toMapFn } from "~/common/utils/reducers";
import { type TechFilterDefinition } from "~/features/selectionAssistant/gearbox/models";

export * as TechValueCodes from "~/features/selectionAssistant/gearbox/components/DimensionsFilter/constants/TechValueCodes";
export const TECH_VALUE_CODE_LIST = Object.values(TechValueCodes);

export const getInitialDimensionValues = (definitions: Record<string, TechFilterDefinition>) => {
  return toMapFn(
    TECH_VALUE_CODE_LIST.map((key) => definitions[key]).filter(Boolean),
    (def) => def.code,
    (def) => [def.min, def.max] as [number, number],
  );
};
